export const getStyle = ({ backgroundColor, paddingTop = 20, paddingBottom = 20 }) => ({
  backgroundColor,
  paddingTop,
  paddingBottom,
});
